<div class="main-box">
  <div class="header-box d-flex flex-wrap w-100 justify-content-between">
    <h2 class="mt-2 mb-2">{{ titleForm }}</h2>
    <!-- Add Row and Column Buttons -->
    <div class="d-flex" *ngIf="!isLoading">
      <div class="update-button">
        <button mat-raised-button color="primary" (click)="addRow()">{{addButtonName}}</button>
      </div>
      <div class="update-button">
        <button mat-raised-button color="primary" (click)="addColumn()">Add Project</button>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="table.rows" class="mat-elevation-z8 table-responsive">
      <!-- Sr. No. Column -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
        <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="warn" (click)="removeRow(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Utility Name -->
      <ng-container matColumnDef="utilityName" *ngIf="isUtility">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let row"> {{ 'Utility Cost' }} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Sub Contractor Description -->
      <ng-container matColumnDef="Descriptionofactivitiesundertaken" *ngIf="isSubContractor">
        <th mat-header-cell *matHeaderCellDef> Description of activities undertaken </th>
        <td mat-cell *matCellDef="let row"> {{ 'Description of activities undertaken' }} </td>
        <!-- need to change -->
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Sub Contractor Description -->
      <ng-container matColumnDef="Descriptionofactivitiesundertakentext" *ngIf="isText">
        <th mat-header-cell *matHeaderCellDef> Description of activities undertaken </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <input matInput [(ngModel)]="row.description"
              placeholder="Description of activities undertaken" />
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Sub Contractor Description -->
      <ng-container matColumnDef="Descriptionofactivitiesundertaken" *ngIf="isContractor">
        <th mat-header-cell *matHeaderCellDef> Description of activities undertaken </th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="text" [(ngModel)]="row.Descriptionofactivitiesundertaken"
            placeholder="Description of activities undertaken" />
        </td>
        <!-- need to change -->
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Name Column with Employee Dropdown -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <mat-select [(ngModel)]="row.mappingId" (selectionChange)="getJobRoleAndCost(row.mappingId, row)">
              <mat-option *ngFor="let item of dropDownList" [value]="item.id">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Job Role Column -->
      <ng-container matColumnDef="jobRole">
        <th mat-header-cell *matHeaderCellDef> Job Role </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <input matInput [(ngModel)]="row.jobRole" placeholder="Job Role" readonly="true" />
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Eligible Staffing Costs Column -->
      <ng-container matColumnDef="eligibleStaffingCosts">
        <th mat-header-cell *matHeaderCellDef> Eligible Costs (£) </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <input matInput [(ngModel)]="row.eligibleStaffingCosts" type="text"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{0,4}).*/, '$1');"
              placeholder="Eligible Staffing Costs" readonly="true" />
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <ng-container *ngIf="calculateEligibleStaffingCostsSum() > 0">
            £{{ calculateEligibleStaffingCostsSum() | number: '1.2-2' }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Dynamic Project Columns -->
      <ng-container *ngFor="let project of table.projects; let i = index" [matColumnDef]="'project' + i">
        <th mat-header-cell *matHeaderCellDef>
          <div class="project-header">
            <mat-form-field>
              <input matInput [(ngModel)]="table.projects[i].projectName" placeholder="Project Name"
                [disabled]="true" />
            </mat-form-field>
            <button mat-icon-button color="warn" (click)="removeColumn(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field>
            <input matInput oninput="
                  this.value = this.value
                    .replace(/[^0-9.]/g, '')                 /* Only allow numbers and a single decimal point */
                    .replace(/(\..*)\./g, '$1')              /* Prevent multiple decimal points */
                    .replace(/^(\d{1,2})(\.\d{0,4})?.*$/, '$1$2')  /* Allow up to 2 digits before decimal and 4 digits after decimal */
                    .replace(/^100(\.0{0,4})?$/, '100$1')    /* Allow exactly 100, or 100.0000 */
                    .replace(/^(\d?\d?\d?)(\.?\d{0,4})?$/, (match, p1, p2) => p1 > 100 ? '100' + (p2 || '') : match); "
              type="text" [(ngModel)]="row.rAndDEligibility[i]" placeholder="R&D %" />
          </mat-form-field>
        </td>
        <!-- Footer cell for Project column total -->
        <td mat-footer-cell *matFooterCellDef>£{{ calculateProjectTotal(i) | number: '1.2-2' }}</td>
      </ng-container>

      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef> Total (£) </th>
        <td mat-cell *matCellDef="let row">
          £{{ calculateTotal(row) | number: '1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="fs-6">
          <ng-container *ngIf="calculateOverallTotalColumn() > 0">
            £{{ calculateOverallTotalColumn() | number: '1.2-2' }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Header, Row, and Footer Declarations -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </div>
  <!-- Totals Table -->
  <div class="totals-table">
    <table class="table table-responsive">
      <tbody>
        <!-- Overall Total Row -->
        <tr class="overall-total-row fs-5">
          <td class="overall-total-label">Overall Total (£)</td>
          <td>£{{ calculateOverallTotalColumn() | number: '1.2-2' }}</td>
        </tr>
        <!-- Eligible Staffing Costs Total Row -->
        <tr class="eligible-costs-total-row fs-5">
          <td class="eligible-costs-label">Sum of Eligible Costs (£)</td>
          <td>£{{ calculateEligibleStaffingCostsSum() | number: '1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Submit Button -->
  <div class="update-button text-center">
    <button mat-raised-button color="primary" (click)="submitData()" [disabled]="isTableEmpty()">Submit</button>
  </div>
</div>